import { createId } from "../../app/runtimeContext";
import type { ToolRegistry } from "../tools/toolRegistry";
import type { CyanIntelligenceRepository } from "./repositories";
import type { ProductContext, ToolIntent } from "./liveTypes";
import type { ExecutionPlan } from "./types";

export class ToolIntentService {
  constructor(
    private readonly repository: CyanIntelligenceRepository,
    private readonly tools: ToolRegistry,
    private readonly environment: "development" | "staging" | "production",
  ) {}

  async createForPlan(
    plan: ExecutionPlan,
    context: ProductContext,
  ): Promise<ToolIntent[]> {
    const required = ["github", "supabase", "cloudflare"];
    const intents = this.tools
      .list()
      .filter((tool) => required.includes(tool.name.toLowerCase()))
      .map<ToolIntent>((tool) => ({
        id: createId("tool_intent"),
        organizationId: context.organizationId,
        productId: context.productId,
        planId: plan.id,
        tool: tool.name,
        purpose: `May be required to implement or verify ${plan.summary}`,
        requestedOperation: "future-owner-approved-operation",
        environment: this.environment,
        permissionsNeeded: [
          "owner approval",
          `${tool.name.toLowerCase()}:execute`,
        ],
        risk: tool.connected ? "medium" : "high",
        costEstimate: "placeholder: no external API call made",
        approvalRequired: true,
        connectionStatus: tool.connected ? "connected" : "disconnected",
        status: tool.connected ? "ready" : "blocked",
        blockedReason: tool.connected
          ? undefined
          : `Connect ${tool.name} outside SS before execution.`,
      }));
    for (const intent of intents) await this.repository.saveToolIntent(intent);
    return intents;
  }
}
